import DocumentFormatPattern from '@/domain/models/document-format-pattern-model'
import { applyHiddenMask } from '@/domain/models/data-format-pattern-model'
import { isValidCnpj, normalizeCnpj } from './cnpj'

// CNPJ alfanumérico (RFB): 12 primeiras posições [0-9A-Z], 2 últimas numéricas.
// prepareChar força uppercase; os blocos aceitam letras+dígitos (DV apenas dígitos).
const DocumentCnpjFormatPattern: DocumentFormatPattern<string> = {
  normalize: (value: string) => normalizeCnpj(value),
  prepareChar: str => str.toUpperCase(),
  placeholder: 'AA.AAA.AAA/AAAA-00',
  mask: '`a{.}`b{.}`c{/}`d{-}`e',
  hiddenMask: '**.*\\*\\*.\\*\\*\\*/\\*\\*\\*\\*-00',
  hide: (value: string) =>
    applyHiddenMask(
      value?.substring(0, 3) + value?.at(-2) + value?.at(-1),
      DocumentCnpjFormatPattern.hiddenMask!
    ),
  blocks: {
    a: { mask: /^[0-9A-Z]{0,2}$/ },
    b: { mask: /^[0-9A-Z]{0,3}$/ },
    c: { mask: /^[0-9A-Z]{0,3}$/ },
    d: { mask: /^[0-9A-Z]{0,4}$/ },
    e: { mask: /^[0-9]{0,2}$/ }
  },
  isValid: (value?: string): boolean => {
    return DocumentCnpjFormatPattern.validate?.(value) === true
  },
  validate: (value?: string): boolean => {
    if (!value) return false
    return isValidCnpj(value)
  },
  rules: {
    minLength: {
      value: 18,
      message: 'Insira exatos 18 caracteres neste campo'
    },
    maxLength: {
      value: 18,
      message: 'Insira exatos 18 caracteres neste campo'
    }
  }
}

export default DocumentCnpjFormatPattern
